import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

@Component({
  selector: 'app-add-loan',
  templateUrl: './add-loan.component.html',
  styleUrls: ['./add-loan.component.scss'],
})
export class AddLoanComponent implements OnInit {

  formData: FormGroup;
  bankList: any;
  formEntity: any;
  idForm = 0;
  showAdd = true;

  constructor(
    private headerService: HeaderService,
    public copyService: CopyService,
    private fb: FormBuilder,
    private parametersService: ParametersService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private helperService: HelpersService,
    private bitacoraService: BitacoraService,
  ) {
    this.headerService.show(true, true, true);
    this.bankList = this.parametersService.getSetting(OpEnum.LOAN_BANK_LIST);
  }

  ngOnInit() {
    const formData = this.abreCuentasService.getFormLoan();
    this.abreCuentasService.setDidBackAddLoan(false);
    if (formData) {
      this.formData = this.fb.group({
        addLoanForm: this.fb.array([]),
      });
      formData.addLoanForm.map((form: any) => {
        const addLoanForm = this.fb.group({
          valuePortfolioForm: [form.valuePortfolioForm, Validators.required],
          entityLoanForm: [form.entityLoanForm, Validators.required],
          freeValueForm: [form.freeValueForm, Validators.required],
          numProductForm: [form.numProductForm, Validators.required],
          nameEntityForm: [form.nameEntityForm],
          nitEntityForm: [form.nitEntityForm],
          idForm: [form.idForm],
          show: [form.show],
        });
        this.idForm = form.idForm;
        this.addLoanForm.push(addLoanForm);
      });
    } else {
      this.formData = this.fb.group({
        addLoanForm: this.fb.array([]),
      });
      this.addLoan();
    }
  }

  get addLoanForm(): FormArray {
    return this.formData.controls['addLoanForm'] as FormArray;
  }

  addLoan() {
    if (this.addLoanForm.length >= 15) {
      this.showAdd = false;
    }
    if (this.addLoanForm.length < 15) {
      const addLoanForm = this.fb.group({
        valuePortfolioForm: ['', Validators.required],
        entityLoanForm: ['', Validators.required],
        freeValueForm: ['', Validators.required],
        numProductForm: ['', Validators.required],
        nameEntityForm: [''],
        nitEntityForm: [''],
        idForm: [this.idForm],
        show: [false],
      });
      this.addLoanForm.push(addLoanForm);
      this.idForm++;
    }
  }

  alphaNumberOnly(event: any) {
    let keyCode: number;
    keyCode = event.keyCode;
    if (event.target.value.length < 10) {
      return this.isNumber(keyCode);
    } else {
      return false;
    }
  }

  isNumber(keyCode: number) {
    return (keyCode >= 48 && keyCode <= 57);
  }

  updateValue(event: any, form: string) {
    const newvalue = this.helperService.currency(event.target.value);
    this.formData.controls[`${form}`].setValue(newvalue.clearValue);
    event.target.value = newvalue.format;
  }

  updateValueForm(index: any, form: string, event: any) {
    index = parseInt(index, 10);
    const value = this.helperService.currency(this.addLoanForm.value[index][`${form}`]);
    // @ts-ignore
    this.addLoanForm.at(index).get(`${form}`).setValue(value.clearValue);
    // this.addLoanForm[index].controls[`${form}`].setValue(value.clearValue);

    event.target.value = value.format;
  }

  showNitName(index: any) {
    // @ts-ignore
    return this.addLoanForm.value[index]['show'];
  }

  selectOther(nit: any, index: any) {
    this.formEntity = nit;
    if (this.formEntity && this.formEntity.nit === '0' && index === this.addLoanForm.value[index]['idForm']) {
      // @ts-ignore
      this.addLoanForm.at(index).get('nitEntityForm').setValidators([Validators.required]);
      // @ts-ignore
      this.addLoanForm.at(index).get('nameEntityForm').setValidators([Validators.required]);
      // @ts-ignore
      this.addLoanForm.at(index).get('show').setValue(true);
    } else {
      // @ts-ignore
      this.addLoanForm.at(index).get('show').setValue(false);
      // @ts-ignore
      this.addLoanForm.at(index).get('nameEntityForm').setValue(nit.name);
      // @ts-ignore
      this.addLoanForm.at(index).get('nitEntityForm').setValue(nit.nit);
    }
  }

  back() {
    this.abreCuentasService.setDidBackAddLoan(true);
  }

  next() {
    this.abreCuentasService.setFormLoan(this.formData.value);
    const formData = this.abreCuentasService.getFormLoan();
    formData.addLoanForm.map(i => {
      const mark = `purchase_${i.valuePortfolioForm} Entity_purchase_${i.entityLoanForm} creditfee_${i.freeValueForm} reference_${i.numProductForm}`;
      this.bitacoraService.saveDataInBitacora(mark);
    });
    const disbursed_method = this.abreCuentasService.getAgreementDetailSelected().disbursed_method;
    if (disbursed_method === '01' || disbursed_method === '03') {
      this.abreCuentasService.setOutlaySelection(BUSINESS_CONST.CHEQUE);
      this.navigationService.nextStep('201');
    } else {
      this.navigationService.nextStep('200');
    }
  }

}
